export const BOOKINGS_TABLE_PAGE_SIZE = 100;
export const MORNING = 'morning';
export const AFTERNOON = 'afternoon';
export const MONDAY = 'MONDAY';
export const TUESDAY = 'TUESDAY';
export const WEDNESDAY = 'WEDNESDAY';
export const THURSDAY = 'THURSDAY';
export const FRIDAY = 'FRIDAY';
export const SATURDAY = 'SATURDAY';
export const SUNDAY = 'SUNDAY';
export const CANCELLED = 'cancelled';
export const COMPLETED = 'completed';
export const CLIENTS_TABLE_PAGE_SIZE = 100;

// Brand Constants
export const HOPE_CLINICS_FULL_NAME = 'Hope Children\'s and Neonatal Hospital';
export const HOPE_CLINICS_CMO_NAME = 'Dr Anthonia Shagaya';
export const HOPE_CLINIC_HEAD_BRANCH =
  'Block 3 , Lakeside Estate,off Victor B.K Crescent, behind Custom quarters, Kado, Abuja';
export const HOPE_CLINICS_WEBSITE = 'https://hopehospital.ng';
export const HOPE_CLINIC_EMAIL = 'info@hopehospital.ng';
